import React, { useEffect } from "react";
import Lenis from "@studio-freight/lenis";
import AOS from "aos";
import "aos/dist/aos.css";
import ConceptRainbow from "../components/ConceptRainbow";
import ConceptMeet from "../components/ConceptMeet";
import ConceptCreate from "../components/ConceptCreate";

const Concept = () => {
  const lenis = new Lenis();

  function raf(time) {
    lenis.raf(time);
    requestAnimationFrame(raf);
  }
  useEffect(() => {
    AOS.init({
      duration: 1000,
    });
    AOS.refresh();
  });

  requestAnimationFrame(raf);

  return (
    <div className="Concept">
      <div className="px__Screen">
        <ConceptRainbow />
        <ConceptMeet />
        <ConceptCreate />
      </div>
    </div>
  );
};
export default Concept;
